import React from 'react';
import styles from './CookiePolicyPage.module.scss';

const Section = ({ title, children }) => (
    <section className={styles.section}>
        <h2 className={styles.sectionTitle}>{title}</h2>
        {children}
    </section>
);

const CookiePolicyPage = () => (
    <div className={styles.page}>
        <div className={styles.container}>

            {/* ── COOKIE POLICY ──────────────────────────────────── */}
            <div className={styles.block}>
                <div className={styles.blockHeader}>
                    <svg width="36" height="36" viewBox="0 0 64 64" fill="none" aria-hidden="true">
                        <path
                            d="M32 6
                               A26 26 0 1 0 58 32
                               L50 28 L56 20 L46 18 L52 10 L42 14 L40 6
                               Z"
                            stroke="#ff79c6" strokeWidth="2.2" fill="none"
                            strokeLinejoin="miter" strokeLinecap="square"
                        />
                        <circle cx="24" cy="24" r="2.8" fill="#ff79c6"/>
                        <circle cx="35" cy="30" r="2.4" fill="#ff79c6"/>
                        <circle cx="22" cy="38" r="2.2" fill="#ff79c6"/>
                        <circle cx="36" cy="44" r="2.5" fill="#ff79c6"/>
                        <circle cx="18" cy="30" r="1.8" fill="#ff79c6"/>
                    </svg>
                    <h1 className={styles.blockTitle}>Политика использования файлов Cookie</h1>
                </div>

                <Section title="Что такое файлы cookie и зачем они нужны?">
                    <p>
                        Файлы cookie — это небольшие текстовые файлы, которые сохраняются на твоём устройстве
                        при посещении платформы <strong>NCORE</strong> (ncore.kg). Они позволяют нам запоминать
                        твои настройки, поддерживать активную сессию авторизации, показывать персонализированный
                        контент и в целом делать платформу быстрее и удобнее.
                    </p>
                    <p>
                        Мы не используем файлы cookie для сбора личной информации без твоего ведома.
                        Все данные применяются исключительно для обеспечения корректной работы NCORE и
                        улучшения твоего опыта на платформе.
                    </p>
                </Section>

                <Section title="Какие cookie мы используем">
                    <ul className={styles.list}>
                        <li>
                            <strong>Сессионные</strong> — поддерживают твою авторизацию на платформе.
                            Удаляются при закрытии браузера.
                        </li>
                        <li>
                            <strong>Функциональные</strong> — сохраняют настройки интерфейса: тему,
                            язык, состояние боковой панели и другие предпочтения.
                        </li>
                        <li>
                            <strong>Аналитические</strong> — помогают нам понять, как пользователи
                            взаимодействуют с разделами платформы, чтобы мы могли их улучшать.
                        </li>
                        <li>
                            <strong>Технические</strong> — необходимы для защиты от CSRF-атак,
                            корректной работы WebSocket-соединений и стриминга контента.
                        </li>
                    </ul>
                </Section>

                <Section title="Сторонние сервисы">
                    <p>
                        Некоторые функции платформы могут использовать сторонние сервисы (например,
                        авторизацию через Telegram). Эти сервисы могут устанавливать собственные файлы
                        cookie в соответствии со своими политиками конфиденциальности, которые находятся
                        вне нашего контроля.
                    </p>
                </Section>

                <Section title="Как отключить cookie">
                    <p>
                        Ты можешь отключить файлы cookie в настройках своего браузера. Однако обрати
                        внимание: отключение может привести к тому, что некоторые функции платформы —
                        такие как авторизация, сохранение прогресса и персональные рекомендации — перестанут
                        работать корректно.
                    </p>
                </Section>

                <Section title="Безопасность данных">
                    <p>
                        Мы гарантируем, что данные, собираемые с помощью файлов cookie, не передаются
                        третьим лицам в коммерческих целях. Вся информация используется только внутри
                        платформы NCORE для улучшения сервиса. Мы соблюдаем требования законодательства
                        Кыргызской Республики о защите персональных данных.
                    </p>
                </Section>

                <Section title="Контакт по вопросам cookie">
                    <p>
                        Если у тебя есть вопросы или ты хочешь запросить удаление своих данных — напиши
                        нам: <a href="mailto:support@ncore.kg" className={styles.link}>support@ncore.kg</a>
                    </p>
                </Section>
            </div>

            {/* ── AGENCY AGREEMENT ──────────────────────────────── */}
            {/* <div className={styles.block}>
                <div className={styles.blockHeader}>
                    <svg width="36" height="36" viewBox="0 0 64 64" fill="none" aria-hidden="true">
                        <rect x="10" y="8" width="44" height="52" rx="4" stroke="#9D3EF7" strokeWidth="2" fill="rgba(157,62,247,0.08)"/>
                        <line x1="18" y1="22" x2="46" y2="22" stroke="#9D3EF7" strokeWidth="2" strokeLinecap="round"/>
                        <line x1="18" y1="30" x2="46" y2="30" stroke="#9D3EF7" strokeWidth="2" strokeLinecap="round"/>
                        <line x1="18" y1="38" x2="36" y2="38" stroke="#9D3EF7" strokeWidth="2" strokeLinecap="round"/>
                        <circle cx="46" cy="48" r="10" fill="#190127" stroke="#52e0a2" strokeWidth="2"/>
                        <path d="M42 48L45 51L50 45" stroke="#52e0a2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    <h1 className={styles.blockTitle}>Агентский договор (Оферта)</h1>
                </div>

                <p className={styles.preamble}>
                    Оферта вступает в силу с даты её размещения на платформе NCORE (ncore.kg) и действует
                    до момента её отзыва Агентом. Агент вправе в любое время изменить или отозвать условия
                    Оферты. Продолжение использования платформы после изменений означает согласие с ними.
                    Акцептом Оферты является полная оплата Принципалом заказа в порядке, предусмотренном Офертой.
                </p>

                <Section title="1. Основные понятия">
                    <ul className={styles.list}>
                        <li><strong>1.1. Агент</strong> — ООО «Аервита», рег. номер 300237-3301-ООО.
                            Юр. адрес: Кыргызская Республика, г. Бишкек, Первомайский район,
                            ул. Патриса Лумумбы, 60, оф. 12.</li>
                        <li><strong>1.2. Принципал</strong> — любое лицо, заключившее с Агентом настоящий
                            Договор путём заполнения специальной формы на платформе ncore.kg.</li>
                        <li><strong>1.3. Заказ</strong> — оформленный через платформу запрос Принципала
                            на заключение Агентом от его имени и за его счёт лицензионного / сублицензионного
                            соглашения с Продавцом на приобретение Цифровой Услуги.</li>
                        <li><strong>1.4. Продавец</strong> — третье лицо, с которым Агент обязуется от
                            имени и за счёт Принципала совершать юридические действия, направленные на
                            приобретение Цифровой Услуги.</li>
                        <li><strong>1.5. Цифровая услуга</strong> — виртуальная игровая валюта, игровые
                            предметы, подписки и иные цифровые активы, право использования которых передаётся
                            Принципалу на основании лицензионного / сублицензионного соглашения.</li>
                        <li><strong>1.6. Услуги Агента</strong> — услуги по приобретению Цифровой Услуги,
                            оказываемые Агентом Принципалу через платформу NCORE.</li>
                    </ul>
                </Section>

                <Section title="2. Предмет договора">
                    <ul className={styles.list}>
                        <li><strong>2.1.</strong> Агент обязуется от имени и за счёт Принципала заключить
                            с Продавцом договор на использование Цифровой Услуги и исполнить обязательства
                            Принципала в согласованной части.</li>
                        <li><strong>2.2.</strong> За выполнение поручения Принципал обязуется выплатить
                            Агенту вознаграждение в размере и порядке, установленных настоящим Договором.</li>
                        <li><strong>2.3.</strong> В рамках поручения Агент осуществляет все необходимые
                            расчёты от имени и за счёт Принципала.</li>
                    </ul>
                </Section>

                <Section title="3. Порядок исполнения">
                    <ul className={styles.list}>
                        <li><strong>3.1.</strong> Принципал оформляет Заказ через форму на платформе NCORE,
                            указывая необходимые данные игрового аккаунта (UID, логин/пароль при необходимости,
                            количество игровой валюты или предметов) и адрес электронной почты.</li>
                        <li><strong>3.2.</strong> После подтверждения Заказа Принципал переходит на страницу
                            оплаты и оплачивает его в течение 2 (двух) часов. Неоплата в срок означает
                            отказ от заключения Договора. С момента оплаты Договор считается заключённым.</li>
                        <li><strong>3.3.</strong> Агент исполняет поручение не позднее 48 (сорока восьми)
                            часов с момента заключения Договора.</li>
                        <li><strong>3.4.</strong> Поручение считается выполненным в момент зачисления
                            Цифровой услуги на аккаунт Принципала.</li>
                    </ul>
                </Section>

                <Section title="4. Агентское вознаграждение">
                    <ul className={styles.list}>
                        <li><strong>4.1.</strong> Вознаграждение Агента определяется тарифами, опубликованными
                            на платформе. Агент вправе в одностороннем порядке изменять тарифы; новые тарифы
                            вступают в силу с момента их публикации.</li>
                        <li><strong>4.2.</strong> Стоимость услуг включает НДС 5%, установленный
                            законодательством Кыргызской Республики.</li>
                        <li><strong>4.3.</strong> Принципал уплачивает 100% вознаграждения и стоимости
                            Цифровой Услуги до начала выполнения поручения. Проценты на аванс не начисляются.</li>
                        <li><strong>4.4.</strong> Цена Цифровой Услуги уплачивается Агенту в счёт возмещения
                            затрат, которые будут понесены Агентом за Принципала.</li>
                        <li><strong>4.5.</strong> Расчёты осуществляются в безналичном порядке.</li>
                        <li><strong>4.6.</strong> Обязательства Принципала считаются исполненными с момента
                            зачисления средств на счёт Агента.</li>
                        <li><strong>4.7.</strong> Агентское вознаграждение удерживается из суммы, полученной
                            от Принципала, после исполнения обязательств Агентом.</li>
                    </ul>
                </Section>

                <Section title="5. Права и обязанности сторон">
                    <ul className={styles.list}>
                        <li><strong>5.1.</strong> Принципал обязуется предоставлять полную и достоверную
                            информацию о себе и игровом аккаунте, необходимую для исполнения Договора.</li>
                        <li><strong>5.2.</strong> Принципал несёт полную ответственность за предоставление
                            неверных сведений, повлёкшее невозможность исполнения обязательств Агентом.</li>
                        <li><strong>5.3.</strong> Принципал обязуется оказывать Агенту своевременную
                            информационную поддержку.</li>
                        <li><strong>5.4.</strong> Агент обязуется заключить соответствующий договор с
                            Продавцом на использование Принципалом Цифровой Услуги.</li>
                        <li><strong>5.5.</strong> Агент приступает к выполнению поручения с момента
                            получения полной оплаты. Срок выполнения — не более 48 часов.</li>
                        <li><strong>5.6.</strong> Агент обязуется уведомить Принципала в случае невозможности
                            исполнить поручение.</li>
                        <li><strong>5.7.</strong> Агент вправе отступить от указаний Принципала без предварительного
                            запроса, уведомив об этом в течение 3 дней.</li>
                        <li><strong>5.8.</strong> Возражения в отношении действий Агента Принципал должен
                            направить в течение 48 часов; по истечении срока возражения считаются снятыми.</li>
                        <li><strong>5.9.</strong> Агент вправе передать выполнение поручения субагентам
                            без согласования с Принципалом.</li>
                    </ul>
                </Section>

                <Section title="6. Порядок возврата денежных средств">
                    <ul className={styles.list}>
                        <li><strong>6.1.</strong> Возврат средств осуществляется по письменному заявлению
                            Принципала, направленному на{' '}
                            <a href="mailto:support@ncore.kg" className={styles.link}>support@ncore.kg</a>.
                            В заявлении указываются ФИО и реквизиты счёта для возврата.</li>
                        <li><strong>6.2.</strong> Средства возвращаются на счёт, с которого производилась
                            оплата, либо на счёт, указанный в заявлении.</li>
                        <li><strong>6.3.</strong> Возврат производится в течение 10 (десяти) дней с момента
                            получения заявления.</li>
                        <li><strong>6.4.</strong> Возврат осуществляется за вычетом вознаграждения Агента
                            и расходов, понесённых до прекращения Договора.</li>
                        <li><strong>6.5.</strong> Возврат допускается только до момента исполнения Договора
                            Агентом.</li>
                    </ul>
                </Section>

                <Section title="7. Срок действия договора">
                    <ul className={styles.list}>
                        <li><strong>7.1.</strong> Договор вступает в силу с момента его акцепта и действует
                            до полного исполнения обязательств сторонами.</li>
                        <li><strong>7.2.</strong> Момент подписания со стороны Принципала — перечисление
                            денежных средств на счёт Агента.</li>
                        <li><strong>7.3.</strong> Момент подписания со стороны Агента — размещение
                            настоящего Договора на платформе NCORE.</li>
                        <li><strong>7.4.</strong> Агент вправе расторгнуть Договор в одностороннем порядке,
                            уведомив Принципала в течение 48 часов, с полным возвратом полученных средств.
                            Агент не несёт ответственности за сопутствующие убытки Принципала.</li>
                    </ul>
                </Section>

                <Section title="8. Ответственность сторон">
                    <p>
                        За неисполнение или ненадлежащее исполнение обязательств по Договору стороны
                        несут ответственность в соответствии с законодательством Кыргызской Республики
                        и условиями настоящего Договора.
                    </p>
                </Section>

                <Section title="9. Разрешение споров">
                    <ul className={styles.list}>
                        <li><strong>9.1.</strong> До предъявления иска заинтересованная сторона обязана
                            направить другой стороне письменную претензию с обоснованием требований.</li>
                        <li><strong>9.2.</strong> Претензия должна содержать требования, их обоснование
                            и ссылки на нарушенные нормы; к ней прилагаются подтверждающие документы.</li>
                        <li><strong>9.3.</strong> Сторона, получившая претензию, обязана направить
                            письменный мотивированный ответ в течение 15 календарных дней.</li>
                    </ul>
                </Section>

                <Section title="10. Персональные данные">
                    <ul className={styles.list}>
                        <li><strong>10.1.</strong> Оформляя Заказ на платформе NCORE, Принципал даёт
                            разрешение Агенту обрабатывать его персональные данные в целях исполнения
                            Договора: собирать, хранить, использовать, передавать уполномоченным лицам,
                            обезличивать и удалять.</li>
                        <li><strong>10.2.</strong> Персональные данные обрабатываются в соответствии
                            с Законом КР от 14 апреля 2008 года № 58 «О персональных данных».</li>
                        <li><strong>10.3.</strong> Принимая Оферту, Принципал соглашается на получение
                            от Агента уведомлений, связанных с исполнением поручения.</li>
                        <li><strong>10.4.</strong> Принципал вправе отозвать согласие на обработку
                            персональных данных, направив заявление на{' '}
                            <a href="mailto:support@ncore.kg" className={styles.link}>support@ncore.kg</a>.</li>
                    </ul>
                </Section>

                <Section title="11. Заключительные положения">
                    <ul className={styles.list}>
                        <li><strong>11.1.</strong> Условия Договора применяются к отношениям сторон,
                            возникшим до его заключения.</li>
                        <li><strong>11.2.</strong> Договор действует до момента надлежащего исполнения
                            сторонами своих обязательств.</li>
                        <li><strong>11.3.</strong> Юридически значимые сообщения направляются через
                            платформу или по адресу{' '}
                            <a href="mailto:support@ncore.kg" className={styles.link}>support@ncore.kg</a>.</li>
                        <li><strong>11.4.</strong> Сообщение считается доставленным с момента его
                            поступления адресату, независимо от факта ознакомления.</li>
                    </ul>
                </Section>
            </div> */}

            {/* ── PRIVACY POLICY ────────────────────────────────── */}
            <div className={styles.block}>
                <div className={styles.blockHeader}>
                    <svg width="36" height="36" viewBox="0 0 64 64" fill="none" aria-hidden="true">
                        <path d="M32 6L54 16V32C54 46 32 58 32 58C32 58 10 46 10 32V16L32 6Z"
                            stroke="#52aaff" strokeWidth="2" fill="rgba(82,170,255,0.1)"/>
                        <circle cx="32" cy="28" r="7" stroke="#52aaff" strokeWidth="2" fill="rgba(82,170,255,0.15)"/>
                        <path d="M22 44C22 38.477 26.477 34 32 34C37.523 34 42 38.477 42 44"
                            stroke="#52aaff" strokeWidth="2" strokeLinecap="round"/>
                    </svg>
                    <h1 className={styles.blockTitle}>Соглашение о конфиденциальности</h1>
                </div>

                <p className={styles.preamble}>
                    Настоящее Соглашение о конфиденциальности регулирует порядок сбора, использования и
                    защиты информации о пользователях платформы <strong>NCORE</strong> (ncore.kg),
                    которая может быть признана конфиденциальной или является таковой в соответствии с
                    законодательством Кыргызской Республики. Факт использования платформы и заключение
                    Агентского договора являются полным акцептом настоящего Соглашения.
                </p>

                <Section title="1. Источники информации">
                    <ul className={styles.list}>
                        <li><strong>1.1.</strong> Информация может быть персонифицированной (прямо
                            относящейся к конкретному лицу) и неперсонифицированной (без привязки к
                            конкретному лицу).</li>
                        <li><strong>1.2.</strong> Администрации платформы доступна информация,
                            получаемая следующими способами:
                            <ul className={styles.subList}>
                                <li>данные, предоставляемые пользователем при регистрации и оформлении заказа;</li>
                                <li>переписка через форму обратной связи и электронную почту;</li>
                                <li>техническая информация: IP-адрес, характеристики устройства и ПО,
                                    данные о загруженных файлах;</li>
                                <li>статистика поведения на платформе (просмотренные разделы, время сессии).</li>
                            </ul>
                        </li>
                        <li><strong>1.3.</strong> Конфиденциальной признаётся только информация,
                            хранящаяся в базе данных в зашифрованном виде и доступная
                            исключительно Администрации платформы.</li>
                        <li><strong>1.4.</strong> Информация, добровольно размещённая пользователем
                            в публичных разделах платформы, конфиденциальной не является.</li>
                    </ul>
                </Section>

                <Section title="2. Безопасность">
                    <ul className={styles.list}>
                        <li><strong>2.1.</strong> Платформа NCORE применяет современные технологии
                            защиты данных, включая шифрование при передаче (TLS) и хранении.</li>
                        <li><strong>2.2.</strong> Доступ к личной информации осуществляется через
                            систему авторизации. Пользователь обязан самостоятельно обеспечивать
                            сохранность учётных данных и не передавать их третьим лицам.</li>
                        <li><strong>2.3.</strong> Сбор, хранение и обработка информации осуществляются
                            в соответствии с законодательством Кыргызской Республики.</li>
                        <li><strong>2.4.</strong> Используя платформу, пользователь даёт согласие на
                            обработку своих персональных данных в целях, предусмотренных Агентским договором,
                            и обязуется уведомлять Администрацию об их изменении.</li>
                    </ul>
                </Section>

                <Section title="3. Заключительные положения">
                    <ul className={styles.list}>
                        <li><strong>3.1.</strong> Деятельность Администрации платформы NCORE
                            осуществляется в соответствии с законодательством Кыргызской Республики.
                            Претензии и споры рассматриваются в порядке, предусмотренном законодательством КР.</li>
                        <li><strong>3.2.</strong> Администрация не несёт ответственности за прямые
                            или косвенные убытки, возникшие в результате использования или невозможности
                            использования платформы.</li>
                        <li><strong>3.3.</strong> Условия настоящего Соглашения могут быть изменены
                            Администрацией в одностороннем порядке с уведомлением пользователей
                            через платформу.</li>
                        <li><strong>3.4.</strong> По вопросам, связанным с персональными данными,
                            обращайтесь:{' '}
                            <a href="mailto:support@ncore.kg" className={styles.link}>support@ncore.kg</a></li>
                    </ul>
                </Section>
            </div>

        </div>
    </div>
);

export default CookiePolicyPage;
